<template>
	<div>
		<el-dialog class="login_mask" :visible.sync="is_login" :show-close="show_close" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="before_close" width="346px" @close="closeMask">
			<div class="login_main">
				<div class="login_type" v-show="login_type!=3">
					<p :class="login_type==1?'tab active':'tab'" @click="codeLoginClick">扫码登录</p>
					<p :class="login_type==2?'tab active':'tab'" @click="accountLoginClick">账户登录</p>
				</div>
				<div class="code_login" v-show="login_type==1" v-loading="loadingCode">
					<img class="code" :src="imageCode" />
					<p class="txt">打开手机微信，扫描二维码</p>
				</div>
				<div class="account_login" v-show="login_type==2">
					<div v-if="!is_code_login">
						<el-input v-model="login_phone" placeholder="手机号登录" class="el_input">
							<p class="icons" slot="prefix"><i class="iconfont icon-yonghu"></i></p>
						</el-input>
						<el-input v-model="login_pwd" placeholder="密码" class="el_input" type="password">
							<p class="icons" slot="prefix"><i class="iconfont icon-clock"></i></p>
						</el-input>
					</div>
					<div v-else>
						<el-input v-model="login_phone" placeholder="输入手机号" class="el_input el_in2">
							<p slot="prefix" class="txts">手机号码</p>
						</el-input>
                                                <el-input v-model="reg_captcha" placeholder="请输入验证码" class="el_input el_in2">
                                                <p slot="prefix" class="txts">验证码</p>
                                                </el-input>
                                                <div class="mt-4">
                                                <img class="w-40" :src="captcha_url" @click="refreshCaptcha" />
                                                </div>
						<el-input v-model="login_code" placeholder="短信验证码" class="el_input el_in2">
							<p slot="prefix" class="txts">验证码</p>
							<p slot="suffix" class="getcode" @click="getPhoneCode('2')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
						</el-input>
					</div>
					<p class="change_way">
						<el-checkbox v-model="remember_pwd">记住密码</el-checkbox>
						<span @click="is_code_login=!is_code_login;refreshCaptcha();">
							{{is_code_login?'账号密码登录':'验证码登录'}}
						</span>
					</p>
					<p class="login_btn" @click="loginSubmit">登录</p>
				</div>
				<div class="code_login" v-show="login_type==3" v-loading="loadingCode">
					<div class="code" v-loading="!imageCode">
						<img class="code" :src="imageCode" v-if="imageCode"/>
					</div>
					<p class="txt">扫码关注公众号并绑定手机号</p>
				</div>
				<p class="go_register"> <a href="javascript:;" @click="logout()" v-show="login_type==3" >切换账号</a> 还没账户？<a href="javascript:;" @click="openRegisterMask()">去注册</a></p>
			</div>
		</el-dialog>
		<el-dialog class="register_mask" title="注册账号" :visible.sync="is_register" width="346px">
			<div class="register_main">
				<div class="step1" v-if="reg_step==1">
					<!-- <el-input v-model="yqm" disabled class="el_input el_in2" v-if="yqm">
						<p slot="prefix" class="txts">邀请码</p>
					</el-input> -->
					<el-input v-model="reg_phone" placeholder="输入手机号" class="el_input el_in2">
						<p slot="prefix" class="txts">手机号码</p>
					</el-input>
                                        <!--<el-input v-model="reg_captcha" placeholder="请输入图形验证码" class="el_input el_in2">
                                                <p slot="prefix" class="txts">验证码</p>
                                        </el-input>
                                        <div class="mt-4">
                                                <img class="w-40" :src="captcha_url" @click="refreshCaptcha" />
                                        </div>
					<el-input v-model="reg_code" placeholder="短信验证码" class="el_input el_in2">
						<p slot="prefix" class="txts">验证码</p>
						<p slot="suffix" class="getcode" @click="getPhoneCode('1')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
					</el-input>-->
					<el-input v-model="reg_pwd" type="password" placeholder="输入密码" class="el_input el_in2">
						<p slot="prefix" class="txts">设置密码</p>
					</el-input>
					<el-input v-model="reg_pwd_confirm" type="password" placeholder="再次输入密码" class="el_input el_in2">
						<p slot="prefix" class="txts">确认密码</p>
					</el-input>
					<el-input v-model="yqm" type="text" placeholder="输入邀请码" class="el_input el_in2">
						<p slot="prefix" class="txts">邀请码</p>
					</el-input>
					<p class="register_btn" @click="regSubmit">注册</p>
					<div class="check_line">
						<label class="la"><el-checkbox v-model="reg_checked"></el-checkbox>我已同意并阅读</label>
						<p class="link" @click="$router.push('./notice?type=4&id=3')">《轻货用户协议》</p>
					</div>
				</div>
				<div class="step2" v-if="reg_step==2" v-loading="loadingCode">
					<p class="title" style="padding-bottom: 50px;">扫码关注公众号</p>
					<img class="code" :src="imageCode" />
					<p class="code_txt">打开手机微信，扫描二维码</p>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="subscribe_tips_mask" title="开启公众号消息提醒操作指引" :visible.sync="subscribe_tips_show" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
			<div class="subscribe_tips">
				<img class="subscribe_pic" :src="subscribePic" v-if="subscribePic"/>
				<p class="txt">关注公众号后，请取消消息免打扰设置，否则会错失重要提醒</p>
				<el-button type="danger" style="margin-top:20px;" @click.stop="subscribe_tips_show=false">我已知晓</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import config from "../../assets/js/conf/config";
import common from '../../assets/js/utils/common';
import headDefault from '../../assets/images/head.png';
import subscribePic from '../../assets/images/follow_gzh_tips.png';

export default {
	name: "loginRegister",
	props: {
		
	},
	data() {
		return {
			is_login:false,
			is_register:false,
			login_type:1,
			reg_step:1,
			is_code_login:false,
			reg_phone:"",
			reg_code:"",
			reg_pwd:"",
			reg_pwd_confirm:"",
			reg_captcha:"",
			remember_pwd:false,
			is_get_phone_code:false,
			is_reg_submit:false,
			reg_checked:false,
			phone_second:60,
			imageCode:"",
			login_phone:"",
			login_pwd:"",
			login_code:"",
			is_login_submit:false,
			checkBindTimer:null,
			userId:"",
			loadingCode:false,
			userinfo:"",
			is_loading: false,
			yqm:"",
			captcha_url: '',
			show_close: true,
			subscribe_tips_show: false,
			is_register_code:false,
			subscribePic: subscribePic
		};
	},
	
	created(){
		this.userinfo = this.users?this.users:""
		var query = this.$route.query
		if(query.reg){
			this.is_register = true
			this.yqm = query.yqm
		}
	},
	mounted() {
    this.checkLoginCookie()
	},
	
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
			avatars:(state)=>state.login.avatar,
			ucmenu:(state)=>state.login.ucmenu,
		}),
	},
	watch:{
		show(val) {
			if(val){
				
			}
		}
	},
	
	methods: {
		...mapActions({
			getCodeData:"login/getCodeData",
			getQrcodeData:"login/getQrcodeData",
			checkWxBind:"login/checkWxBind",
			DoAccountLogin:"login/DoAccountLogin",
			DoCodeLogin:"login/DoCodeLogin",
			DoRegister:"login/DoRegister",
			getUcenterMenu:"login/getUcenterMenu",
		}),
		...mapMutations({
			OUT_LOGIN:"login/OUT_LOGIN"
		}),
		closeMask(){//关闭登录注册弹窗
			this.is_login = false
			this.is_register = false
			this.is_get_phone_code = false
			this.phone_second = 60
			this.reg_step = 1
			clearTimeout(this.checkBindTimer)
		},
		before_close(){
			if(this.login_type == 3){
				this.$message({message: '请使用微信扫描二维码绑定',type: 'info',});
				return;
			}
		},
		openLoginMask(){//打开登录弹窗
			this.is_login = true
			setTimeout(()=>{this.loadingCode = true},100)
			this.getLoginCode('',true,'1')

			this.refreshCaptcha()
		},
		openRegisterMask(){
			this.is_register = true
			this.reg_step = 1
			this.refreshCaptcha()
		},
    checkLoginCookie(){
      var businessLoginData = this.$cookies.get('businessLoginData')
      if(businessLoginData){
        this.remember_pwd = businessLoginData.remember_pwd
        this.login_phone = businessLoginData.login_phone
        this.login_pwd = businessLoginData.login_pwd
      }
    },
		getLoginCode(phone='',isCheck=false,type='2'){//获取登录二维码,type=1表示直接通过二维码扫码登录，不需要传手机号
			this.getQrcodeData({data:{
					mobile:phone,
					level:'2',
					bind_uid:'0',
					type:type,
				},success:(res)=>{
				if(res.code===200){
					console.log('get qr code',res)
					this.imageCode = res.msg.ticket_img
					setTimeout(()=>{this.loadingCode = false},1000)
					if(isCheck){
						this.int_uid = res.msg.int_uid
						this.checkBind(res.msg.int_uid)
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		codeLoginClick(){
			this.login_type = 1
			setTimeout(()=>{this.loadingCode = true},100)
			this.getLoginCode('',true,'1')
		},
		accountLoginClick(){
			this.login_type = 2
			clearTimeout(this.checkBindTimer)
		},
		getPhoneCode(ev){//获取短信验证码
			let phone = '';
      if(this.is_login){
        phone = this.login_phone
      }
      if(this.is_register){
        phone = this.reg_phone
      }
			if(!common._verify_mobile(phone)){
				this.$message({message: '请输入正确手机号',type: 'error',});
				return false
			}
		  if(!this.reg_captcha){
		    this.$message({message: '请先输入图形验证码',type: 'error',});
		    return false
		  }
			if(!this.is_get_phone_code){
				this.is_get_phone_code = true
				this.getCodeData({data:{
						mobile:phone,
						event:ev,
		        captcha: this.reg_captcha,
					},success:(res)=>{
					if(res.code===200){
						// console.log('get phone code',res)
						this.$message({message: '发送成功~',type: 'success',});
						let timer = setInterval(()=>{
							this.phone_second -= 1
							if(this.phone_second == 0){
								clearInterval(timer)
								this.phone_second = 60
								this.is_get_phone_code = false
							}
						},1000)
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_get_phone_code = false
						if(res.msg == '请输入正确的图像验证码！'){
							this.refreshCaptcha()
						}
					}
				}})
			}
			
		},
		refreshCaptcha(){
		  this.captcha_url = config.baseApi + '/business/login/captcha?_t=' + new Date().getTime()
		},
		loginSubmit(){//登录提交
			if(!this.login_phone){
				this.$message({message: '请输入手机号码',type: 'error',});
				return false
			}
			if(!this.is_code_login){//账号密码登录
				if(!this.login_pwd){
					this.$message({message: '请输入密码',type: 'error',});
					return false
				}
				if(!this.is_login_submit){
					this.is_login_submit = true
					this.DoAccountLogin({data:{
							mobile:this.login_phone,
							password:this.login_pwd,
						},success:(res)=>{
						this.is_login_submit = false
						if(res.code===200){
							this.setLoginCookie()
							this.$message({message: res.msg,type: 'success',});
							if(res.data == 'null'){
								window.location.reload()
								return
							}
							this.userinfo = res.data.userinfo
							this.avatar = res.data.userinfo.avatar || headDefault
							this.getUCmenu()
							this.refresh()
							if(res.data.userinfo.is_follow==0){
								this.login_type = 3
								this.getLoginCode(this.login_phone,true)
							}else{
								this.closeMask()
								console.log('sssss')
							}
						} else {
							this.$message({message: res.msg,type: 'error',});
							this.is_login_submit = false
						}
					}})
				}
			}else{//短信验证码登录
				if(!this.login_code){
					this.$message({message: '请获取短信验证码',type: 'error',});
					return false
				}
				if(!this.is_login_submit){
					this.is_login_submit = true
					this.DoCodeLogin({data:{
							mobile:this.login_phone,
							code:this.login_code,
						},success:(res)=>{
						if(res.code===200){
							console.log('code login success',res)
							this.userinfo = res.data.userinfo
							this.avatar = res.data.userinfo.avatar || headDefault
							this.getUCmenu()
							this.refresh()
							this.$message({message: res.msg,type: 'success',});
							if(res.data.userinfo.is_follow==0){
								this.login_type = 3
								this.show_close = false
								this.getLoginCode(this.login_phone,true)
							}else{
								this.closeMask()
							}
						} else {
							this.$message({message: res.msg,type: 'error',});
							this.is_login_submit = false
						}
					}})
				}
			}
		},
		setLoginCookie(){
			if(this.remember_pwd && this.login_type == 2){
				var businessLoginData = {remember_pwd:true,login_phone:this.login_phone,login_pwd:this.login_pwd}
				this.$cookies.set('businessLoginData',businessLoginData,'30d')
			}else{
				var businessLoginData = false
				this.$cookies.set('businessLoginData',businessLoginData,'1s')
			}
		},
		getUCmenu(){
			this.getUcenterMenu({data:{},success:(res)=>{
				if(res.status==200){
					console.log('getUCmenu',res)
					// this.employeeData.data = res.data
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		regSubmit(){//注册提交
			if(!common._verify_mobile(this.reg_phone)){
				this.$message({message: '请输入正确手机号',type: 'error',});
				return false
			}
			/*if(!this.reg_code){
				this.$message({message: '请获取短信验证码',type: 'error',});
				return false
			}*/
			if(!this.reg_pwd){
				this.$message({message: '请输入密码',type: 'error',});
				return false
			}
			if(!this.reg_pwd_confirm){
				this.$message({message: '请再次输入密码',type: 'error',});
				return false
			}
			if(this.reg_pwd != this.reg_pwd_confirm){
				this.$message({message: '请确保两次输入的密码一致',type: 'error',});
				return false
			}
			if(!this.yqm){
				this.$message({message: '请输入邀请码',type: 'error',});
				return false
			}
			if(!this.reg_checked){
				this.$message({message: '请阅读并同意用户协议',type: 'error',});
				return false
			}
			if(!this.is_reg_submit){
				this.is_reg_submit = true
				this.DoRegister({data:{
						mobile:this.reg_phone,
						code:this.reg_code,
						password:this.reg_pwd,
						true_password:this.reg_pwd_confirm,
						yqm:this.yqm,
					},success:(res)=>{
					console.log('register success',res)
					if(res.code===200){
						this.$message({message: '注册成功~',type: 'success',});
						this.reg_step = 2
						this.loadingCode = true
						this.is_register_code = true
						this.getLoginCode(this.reg_phone,true)
						setTimeout(()=>{
							this.is_reg_submit = false
							this.reg_phone = ''
							this.reg_code = ''
							this.reg_pwd = ''
							this.reg_pwd_confirm = ''
						},1500)
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_reg_submit = false
						if(res.msg == '请输入正确的图像验证码！'){
							this.refreshCaptcha()
						}
					}
				}})
			}
		},
		checkBind(id){//检测是否微信绑定成功
			// console.log(this.login_type)
			this.checkWxBind({data:{
					int_uid:id,
				},success:(res)=>{
				// console.log('check login',res)
				if(res.code===200){
					this.userinfo = res.data.userinfo
					this.avatar = res.data.userinfo.avatar || headDefault
					this.getUCmenu()
					this.$message({message: res.msg,type: 'success',});
					this.closeMask()
					this.refresh()
					if(this.login_type == 3||this.is_register_code){
						this.showSubscribeTipsMask()
						this.login_type = 1
						this.is_register_code = false
					}
				} else {
					this.checkBindTimer = setTimeout(()=>{
						this.checkBind(this.int_uid)
					},1500)
				}
			}})
		},
		refresh(){
			this.$emit('refresh',{})
		},
		logout(){
			this.$message({message: '已退出登录',type: 'success',});
			this.OUT_LOGIN()
			window.location.reload()
		},
		showSubscribeTipsMask(){
			this.subscribe_tips_show = true
		}
	},

}
</script>

<style scoped>
	
	.register_main{width: 100%;height: auto;box-sizing: border-box;background: #fff;padding: 0 22px 30px;}
	.register_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
	.register_main .title{line-height: 1;font-size: 20px;margin-bottom: 16px;}
	.register_main .in_box{width: 100%;height: 38px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 4px;display: flex;margin-top: 14px;align-items: center;}
	.register_main .in_box .txt{margin-left: 10px;width: 70px;font-size: 14px;color: #999;}
	.register_main .in_box .in{flex: 1;width: 0;margin-right: 14px;font-size: 14px;color: #333333;}
	.register_main .in_box .get_code{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
	.register_main .register_btn{width: 100%;height: 38px;border-radius: 4px;background: #fb5758;display: flex;justify-content: center;align-items: center;color: #ffffff;font-size: 14px;cursor: pointer;margin-top: 35px;}
	.register_main .check_line{display: flex;align-items: center;font-size: 14px;margin-top: 14px;}
	.register_main .code{display: block;width: 155px;height: 155px;margin: 16px auto 0;}
	.register_main .code_txt{margin-top: 28px;text-align: center;font-size: 14px;color: #666666;}
	.register_main .check_line .link{color: #fb5758;cursor: pointer;}
	.login_main{width: 100%;height: auto;box-sizing: border-box;background: #fff;padding: 26px 0 28px;}
	.login_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
	.login_main .login_type{padding: 14px 0;border-bottom: 1px solid #eee;display: flex;line-height: 1;}
	.login_main .login_type .tab{flex: 1;text-align: center;font-size: 18px;cursor: pointer;}
	.login_main .login_type .tab.active{font-weight: bold;color: #fb5758;}
	.login_main .code_login{margin: 38px 0 55px;display: flex;flex-direction: column;align-items: center;}
	.login_main .code_login .code{width: 155px;height: 155px;background-color: #eee;}
	.login_main .code_login .txt{margin-top: 24px;line-height: 1;font-size: 14px;color: #666666;text-align: center;}
	.login_main .account_login{margin: 0 22px 55px;padding-top: 20px;}
	.login_main .account_login .in_box{width: 100%;height: 38px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 4px;display: flex;margin-top: 14px;align-items: center;}
	.login_main .account_login .in_box .icons{width: 38px;height: 100%;border-right: 1px solid #ddd;background: #f5f5f5;display: flex;justify-content: center;align-items: center;}
	.login_main .account_login .in_box .icons .iconfont{font-size: 20px;color: #cccccc;}
	.login_main .account_login .in_box .in{flex: 1;width: 0;margin: 0 14px;font-size: 14px;color: #333333;}
	.login_main .account_login .in_box .txt{margin-left: 10px;width: 60px;font-size: 14px;color: #999;}
	.login_main .account_login .in_box .get_code{font-size: 14px;color: #666;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
	.login_main .account_login .change_way{margin-top: 20px;line-height: 1;display: flex;justify-content: space-between;}
	.login_main .account_login .change_way>span{font-size: 14px;color: #333333;cursor: pointer;}
	.login_main .account_login .login_btn{width: 100%;height: 38px;border-radius: 4px;background: #fb5758;display: flex;justify-content: center;align-items: center;color: #ffffff;font-size: 14px;cursor: pointer;margin-top: 35px;}
	.login_main .go_register{margin: 0 30px;text-align: right;font-size: 14px;line-height: 1;}
	.login_main .go_register>a{color: #fb5758;text-decoration: underline;cursor: pointer;}
	.home_main{width: 100%;height: auto;margin-top: 30px;margin-bottom: 40px;}
	.register_mask .el-dialog__body,.login_mask .el-dialog__body,.login_mask .el-dialog__header{padding: 0;}
	.el_input.el_in2 .el-input__prefix{top: 0;left: 0;}
	.el_input{display: flex;margin-top: 14px;}
	.el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
	.el_input .el-input__inner:focus{border-color: var(--red);}
	.el_input.el_in2 .el-input__inner{padding-left: 90px;}
	.account_login .el_input .el-input__prefix{left: 1px;top: 1px;height: 36px;}
	.el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
	.el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
	.el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;padding-left: 10px;}
	.el_input .el-input__suffix{display: flex;}
	.el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;}
	.el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
	.register_main .check_line .el-checkbox{margin-right: 8px;margin-top: 2px;}
	.el-checkbox__input.is-focus .el-checkbox__inner{border-color: #DCDFE6 !important;}
	.el-checkbox__input.is-checked .el-checkbox__inner{background-color: #fb5758 !important;border-color: #fb5758 !important;}
	.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{background-color: #ffedee;color: #fa5757;}
	.subscribe_tips_mask .subscribe_tips{display: flex;flex-direction: column;align-items: center;}
	.subscribe_tips_mask .subscribe_tips .subscribe_pic{width: 800px;}
	.subscribe_tips_mask .subscribe_tips .txt{font-size: 20px;color: var(--red);text-align: center;margin-top: 20px;}
</style>

<style>
.el_input.el_in2 .el-input__prefix{top: 0;left: 0;}
.el_input{display: flex;margin-top: 14px;}
.el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.el_input .el-input__inner:focus{border-color: var(--red);}
.el_input.el_in2 .el-input__inner{padding-left: 90px;}
.account_login .el_input .el-input__prefix{left: 1px;top: 1px;height: 36px;}
.el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;padding-left: 10px;}
.el_input .el-input__suffix{display: flex;}
.el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;}
.el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
.register_main .check_line .el-checkbox{margin-right: 8px;margin-top: 2px;}
.el-checkbox__input.is-focus .el-checkbox__inner{border-color: #DCDFE6 !important;}
.el-checkbox__input.is-checked .el-checkbox__inner{background-color: #fb5758 !important;border-color: #fb5758 !important;}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{background-color: #ffedee;color: #fa5757;}
</style>